import $ from 'cash-dom';

$(function () {
	$('.copy-btn').on('click', function (e) {
		e.preventDefault();

		const copyButton = $(this);
		const code = copyButton.data('promocode');
		let copiedBlock = copyButton.closest('.promocode-holder').find('.copied');

		if (code) {
			navigator.clipboard.writeText(code);
			copyButton.css('display', 'none');
			copiedBlock.css('display', 'inline-flex');
		}

		setTimeout(function () {
			copiedBlock.css('display', 'none');
			copyButton.css('display', 'inline-flex');
		}, 3000);
	});

	$('.copied').on('click', function (e) {
		e.preventDefault();
	});
});
